// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Taxes from '../components/Taxes';
import {actions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    isFetching: state.taxesConfig.isFetching,
    taxes: state.taxesConfig.taxes,
    saveSuccess: state.taxesConfig.saveSuccess,
    error: state.coupons.error,
    taxFilterState: state.taxesConfig.taxFilterState,
    currency: state.currency.currency,
    store: state.store.store,
    information: state.ui.storeInformation,
  }),
  (dispatch: Dispatch<any>) => (dispatch: Dispatch<any>) =>
    bindActionCreators({...actions}, dispatch)
)(Taxes);
